import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="w-full max-w-[min(100%,72rem)] mx-auto px-4 lg:px-10 py-16 text-center text-gray-200">
      <p className="text-6xl font-bold text-gray-600 mb-4">404</p>
      <h1 className="text-2xl font-semibold text-gray-100 mb-2">Page not found</h1>
      <p className="text-gray-500 mb-6">
        The document or page you are looking for does not exist.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm font-medium rounded-lg px-4 py-2 min-h-[44px] bg-primary-900/40 border border-primary-700/50 text-primary-100 hover:bg-primary-900/60"
      >
        Back to wiki
      </Link>
    </div>
  )
}
